import toKebab from './toKebab'
import isString from './isString'
import isNumber from './isNumber'

const objToQuery = obj => {
  const features = Object.keys(obj)

  let mq = ''

  features.forEach((feature, index) => {
    let value = obj[feature]
    feature = toKebab(feature)

    // Add px to dimension features
    if (feature.match(/[height|width]$/) && isNumber(value)) {
      value = value + 'px'
    }

    if (value === true) {
      mq += feature
    } else if (value === false) {
      mq += 'not ' + feature
    } else {
      mq += '(' + feature + ': ' + value + ')'
    }

    if (index < features.length - 1) {
      mq += ' and '
    }
  })

  return mq
};

const toMediaQuery = query => {
  if (isString(query)) {
    return query
  }

  // Handling array of media queries
  if (query instanceof Array) {
    let mq = ''

    query.forEach(function (subquery, index) {
      mq += objToQuery(subquery)

      if (index < query.length - 1) {
        mq += ', '
      }
    })

    return mq
  }

  // Handling single media query
  return objToQuery(query)
}

export default toMediaQuery
